import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Ellipsis } from 'lucide-react';
import { memo, useState } from 'react';
import AddedOrderProductDropdown from '../../../../../products/products-details-v2/components/AddedOrderProductDropdown/AddedOrderProductDropdown';
import useOrderProductGridButtonStyles from '../../grid/components/orderProductGrid/components/buttons/styles/useOrderProductGridButtonStyles';
import { OrderProductActionsProps } from './OrderProductActions.interfaces';

const OrderProductActions = ({
  removeActionCustomLabel,
  handleClickRemove,
  hasTouchLayout,
}: OrderProductActionsProps) => {
  const { classes } = useOrderProductGridButtonStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <AddedOrderProductDropdown
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        handleClose={() => setAnchorEl(null)}
        onClickRemove={handleClickRemove}
        removeActionCustomLabel={removeActionCustomLabel}
      />
      <IconButton
        tabIndex={-1}
        icon={Ellipsis}
        color="primary"
        size={hasTouchLayout ? 'large' : 'medium'}
        className={hasTouchLayout ? classes.endMobileBaseButton : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      />
    </>
  );
};

export default memo(OrderProductActions);
